module.exports = __webpack_public_path__ + "img/vue-logo.8a508938.png";